<template>
    <div id="debugWindow" ref="debugWindow" style="top: 2px; left: 10px">
        <div id="debugWindowHeader">Окно отладки</div>
<!--        <div id="debugThreejs"></div>-->
<!--        <canvas id="debugCanvas"></canvas>-->

<!--        <img id="debugTesture" >-->
        <button style="width:90px;" @click="forTest">Добавить planeGroup</button>
        <button style="width:90px;" @click="forTest2">Добавить planeGroup</button>
    </div>
</template>

<script>
    export default {
        name: "TheDebug.vue",
        mounted() {
            // this.oldClientX = null;
            // this.oldClientY = null;
            this.moving = (e) => {
                if (this.oldClientX) {
                    let deltaX = e.clientX - this.oldClientX;
                    let deltaY = e.clientY - this.oldClientY;
                    this.$refs["debugWindow"].style.left = (parseInt(this.$refs["debugWindow"].style.left) + deltaX) + 'px';
                    this.$refs["debugWindow"].style.top = (parseInt(this.$refs["debugWindow"].style.top) + deltaY) + 'px';
                }
                this.oldClientX = e.clientX;
                this.oldClientY = e.clientY;
            }
            this.$refs["debugWindow"].addEventListener("mousedown", (cb) => {
                this.$refs["debugWindow"].addEventListener("mousemove", this.moving)
            });
            this.$refs["debugWindow"].addEventListener("mouseup", (cb) => {
                this.$refs["debugWindow"].removeEventListener("mousemove", this.moving)
                this.oldClientX = null;
                this.oldClientY = null;
            })
            console.log(this.$store.getters["active/PLANE_GROUP_LIST"]);
        },
        methods:{
            forTest() {
                this.$store.dispatch('active/CREATE_PLANE_GROUP', {
                    name: 'Первая группа',
                    color: '#222222'
                })
            },
            forTest2() {
                this.$store.dispatch('active/ADD_DESIGN_GROUP', {
                })
            },
        }
    }
</script>

<style scoped>
    #debugWindow {
        width: 500px;
        height: 500px;
        position: absolute;
        z-index: 500;
        background: black;
    }

    #debugWindowHeader {
        background-color: darkorange;
        text-align: center;
    }

    #debugTesture {
        /*width: 500px;*/
        /*height: 500px;*/
        /*display: none;*/
    }

</style>
